import { createContext } from 'react';
export const SearchModuleContext = createContext(null);
SearchModuleContext.displayName = 'SearchModule';
//# sourceMappingURL=SearchModuleContext.js.map